import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  
  return getRequest(`emailDelivery/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`emailDelivery/edit/${id}`)
}

export async function save(values) {
  return postRequest(`emailDelivery/save`, values)
}

export function remove(values) {
  return postRequest(`emailDelivery/delete`, values)
}
